import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { adminApi, inr, STATUS_LABEL, PAY_METHOD, PAY_STATUS, REFUND_STATUS } from "@/lib/api";
import { PageTitle, Pill, statusTone, payTone, Btn } from "@/admin/ui";

const Sel = ({ value, onChange, options, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="h-9 rounded-md border border-stone-300 bg-white px-2 text-sm">
    {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

export default function AdminOrders() {
  const [params, setParams] = useSearchParams();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const f = { status: params.get("status") || "", payment_status: params.get("payment_status") || "", date: params.get("date") || "", q: params.get("q") || "" };
  const [q, setQ] = useState(f.q);
  const key = params.toString();

  useEffect(() => {
    const p = Object.fromEntries([...new URLSearchParams(key)].filter(([, v]) => v));
    adminApi.get("/orders", { params: p }).then((r) => setOrders(r.data));
  }, [key]);

  const setF = (k, v) => { const n = new URLSearchParams(params); v ? n.set(k, v) : n.delete(k); setParams(n); };

  return (
    <div>
      <PageTitle sub={`${orders.length} orders`}>Orders</PageTitle>
      <div className="flex flex-wrap gap-2 mb-3 bg-white border border-stone-200 rounded-md p-3" data-testid="order-filters">
        <Sel value={f.status} onChange={(v) => setF("status", v)} testId="filter-status" options={[["", "All statuses"], ...Object.entries(STATUS_LABEL)]} />
        <Sel value={f.payment_status} onChange={(v) => setF("payment_status", v)} testId="filter-payment" options={[["", "All payments"], ...Object.entries(PAY_STATUS)]} />
        <Input type="date" value={f.date} onChange={(e) => setF("date", e.target.value)} className="h-9 w-40" data-testid="filter-date" />
        <form onSubmit={(e) => { e.preventDefault(); setF("q", q); }} className="flex gap-2">
          <Input placeholder="Order no, phone, name" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 w-56" data-testid="filter-search" />
          <Btn variant="outline" data-testid="filter-search-btn">Search</Btn>
        </form>
        {key && <Btn variant="ghost" onClick={() => { setQ(""); setParams({}); }} data-testid="filter-clear-btn">Clear</Btn>}
        <Btn variant="outline" className="ml-auto" onClick={() => nav(`/admin/slips?date=${f.date || new Date(Date.now() + 19800000).toISOString().slice(0, 10)}`)} data-testid="print-all-slips-btn">Print slips{f.date ? ` (${f.date})` : " (today)"}</Btn>
      </div>
      <div className="bg-white border border-stone-200 rounded-md overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Order</TableHead><TableHead>Customer</TableHead><TableHead>Slot</TableHead>
              <TableHead>Status</TableHead><TableHead>Payment</TableHead><TableHead>Refund</TableHead><TableHead className="text-right">Due</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.map((o) => (
              <TableRow key={o.id} onClick={() => nav(`/admin/orders/${o.id}`)} className="cursor-pointer" data-testid={`admin-order-row-${o.id}`}>
                <TableCell><p className="font-bold text-primary">{o.order_number}</p><p className="text-xs text-stone-500">{o.delivery_date}</p></TableCell>
                <TableCell><p>{o.name}</p><p className="text-xs text-stone-500">{o.phone} · {o.pincode}</p></TableCell>
                <TableCell className="text-xs">{o.slot_label}</TableCell>
                <TableCell><Pill tone={statusTone(o.status)}>{STATUS_LABEL[o.status]}</Pill>{o.cod_approval === "pending" && o.status !== "cancelled" && <div className="mt-1"><Pill tone="orange" testId={`cod-pending-pill-${o.id}`}>COD approval</Pill></div>}</TableCell>
                <TableCell><p className="text-xs">{PAY_METHOD[o.payment_method]}</p><Pill tone={payTone(o.payment_status)}>{PAY_STATUS[o.payment_status]}</Pill></TableCell>
                <TableCell>{o.refund_total > 0 ? <Pill tone={o.refund_status === "pending" ? "orange" : "green"}>{REFUND_STATUS[o.refund_status]} · {inr(o.refund_total)}</Pill> : "—"}</TableCell>
                <TableCell className="text-right font-bold">{inr(o.amount_due)}</TableCell>
              </TableRow>
            ))}
            {orders.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-stone-500 py-10" data-testid="admin-no-orders">No orders match.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
